'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const PubSub = require('../PubSub');
const template = require('../templates/contestant.ejs');
const slugify = require('./../util/helpers').slugify;

module.exports = Backbone.View.extend({
    className: 'contestant flex-child-container',
    events: {
        'click .btn-minus': 'minusVote',
        'click .btn-plus': 'plusVote',
        'click .img-position': 'loadVideo',
        'click .edit-container': 'handleContainerClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};
        this.category = options.category;
        this.user = options.user;
        this.temp = options.temp;
        this.voteLimit = parseInt(options.cms.turboVote.get('voteLimit'), 10);
        
        this.customization = options.customization;

        this.listenTo(this.user, 'change:isAuthorized', function(){
            this.$el.removeClass('voted');
            this.$el.find('.overlay').hide();
        }.bind(this));

        this.person = options.person;
        this.dimensions = options.dimensions;
        this.copy = options.copy;
        this.professional = options.professional;
        this.social = options.social;
        this.category = options.category;

        this.width = 50;
        this.height = 50;
        this.imageQsp = '?';
        this.incrementAfterAuth = false;

        this.blankContestant = options.blankContestant || false;

        this.listenTo(this.user, 'change:isAuthorized', function(model, isAuth) {
            if(isAuth && this.incrementAfterAuth) {
                this.incrementAfterAuth = false;
                this.plusVote();
            }
        }.bind(this));

        this.listenTo(this.model, 'change:voteCount', this.updateVoteUI.bind(this));
        this.listenTo(this.category, 'change:isSubmitted', this.checkCatSubmitted.bind(this));
        this.listenTo(this.category, 'updateEditButtons', this.updateVoteUI.bind(this));
        this.listenTo(this.category, 'updatePlusButtons', this.updatePlusButtons.bind(this));
    },
    /**
     *
     */
    render: function () {

        var isWinner = _.checkIfTrue( this.model.get('winner') );

        if (isWinner) {
            this.$el.addClass('winner');
        }

        var modelData = _.extend({}, this.model.toJSON(), {
            voteLimit: this.voteLimit,
            singleVote: this.singleVote,
            copy: this.copy,
            professional: this.professional,
            social: this.social,
            active: this.category.get('active'),
            live_vote: this.category.get('live_vote'),
            winner: isWinner
        });

        var updatedModel = this.buildImageURLs(modelData);

        if(this.temp) {
            this.$el.addClass('temp');
        }

        this.$el.html(template(updatedModel));
        this.$el.find('img').unveil(2 * window.innerHeight);

        return this;
    },
    /**
     * https://telescopetv.atlassian.net/browse/MV-1159
     * this fixes an issue that causes ios safari to zoom in on double tap
     */
    handleContainerClick: function (e) {
        e.preventDefault();
    },
    /**
     * [buildImageURLs description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    buildImageURLs: function(data) {
        var node = (parseInt(this.person)) ? 'circle' : 'rectangle';

        _.forEach(this.dimensions[node], function(value, index){
            if(value != '') {
                this.imageQsp = this.imageQsp + index + '=' + value + "&";

                if(/(width)/.test(index)) {
                    this.width = value;
                } else if(/(height)/.test(index)) {
                    this.height = value;
                }
            }
        }.bind(this));

        this.imageQsp = this.imageQsp.slice(0,-1);

        data.formatted_image = data.image_url.length > 0 ? data.image_url + this.imageQsp : '';
        data.width = this.width;
        data.height = this.height;
        data.external_url = data.external_url || '';

        return data
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function(toBeIncremented) {

        if(toBeIncremented) this.plusVote();

        this.checkCatSubmitted();
    },
    /**
     * Update contestant UI once category is submitted
     */
    checkCatSubmitted: function() {
        if(this.category.get('isSubmitted')) {
            this.$el.addClass('voted');
            this.disableEditButtons();
            return true;
        }
        return false;
    },
    /**
     * Disable all edit buttons when user has submitted the category
     */
    disableEditButtons: function() {
        this.$('.btn-minus').prop('disabled', 'disabled');
        this.$('.btn-plus').prop('disabled', 'disabled');
    },
    /**
     * Subtract vote count
     */
    minusVote: function(e) {
        e.preventDefault();

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'minus button_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')),
            url: window.location.href
        };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Minus Button' };
        PubSub.trigger('linkClick', omParams, gaParams);

        var votes = this.model.get('voteCount');
        var totalAllocatedVotes = this.category.get('totalAllocatedVotes');
        if(totalAllocatedVotes > 0 && votes > 0) {
            this.model.set('voteCount', votes - 1);
            this.category.updateEditButtons();
            this.category.voteCountUpdate('minus', this.model.get('id'), this.model.get('voteCount'));
        }
    },
    /**
     * Add vote count
     */
    plusVote: function(e) {
        if(e) e.preventDefault();

        if(!this.user.get('isAuthorized')) {
            var selected = {
                categoryID: this.category.get('id'),
                contestantID: this.model.id
            };
            this.incrementAfterAuth = true;
            return PubSub.trigger('directRoute', 'auth', selected);
        }

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'plus button_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')), 
            url: window.location.href
        };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Plus Button' };
        PubSub.trigger('linkClick', omParams, gaParams);

        var votes = this.model.get('voteCount');
        var totalAllocatedVotes = this.category.get('totalAllocatedVotes');
        if(totalAllocatedVotes < this.voteLimit && votes < this.voteLimit) {
            this.model.set('voteCount', votes + 1);
            this.category.voteCountUpdate('plus', this.model.get('id'), this.model.get('voteCount'));
        }
    },
    /**
     * Update the edit buttons and vote count in the UI
     */
    updateVoteUI: function(data) {
        if(typeof data === 'string' && data !== this.category.get('id')) return;

        var voteCount = this.model.get('voteCount');
        this.$('.vote-count').text(voteCount);

        if(this.checkCatSubmitted()) return;

        if(!voteCount) {
            this.$('.btn-minus').prop('disabled', 'disabled');
            this.$('.btn-plus').prop('disabled', false);
        } else if(voteCount === this.voteLimit) {
            this.$('.btn-plus').prop('disabled', 'disabled');
        } else {
            this.$('.btn-minus').prop('disabled', false);
            this.$('.btn-plus').prop('disabled', false);
        }
    },
    /**
     * Update the plus buttons once all votes are allocated for category
     */
    updatePlusButtons: function(categoryID) {
        if(categoryID && categoryID === this.category.get('id')) {
            this.$('.btn-plus').prop('disabled', 'disabled');
        }
    },
    /**
     *
     */
    loadVideo: function(e) {
        if(this.temp || !this.model.get('video_url')) return;

        var lowerCategoryName = this.category.get('name').toLowerCase();
        var lowerContestantName = this.model.get('name').toLowerCase();

        var omParams = {
            name: 'video_' + lowerCategoryName + '_' + lowerContestantName,
            section: slugify(this.category.get('name')), 
            url: window.location.href
        };
        var gaParams = {
            eventCategory: 'Button Click',
            eventAction: 'Watch Video : ' + this.category.get('name') + ' : ' + this.model.id
        };
        PubSub.trigger('loadVideo', this.model.toJSON(), this.category);
        PubSub.trigger('linkClick', omParams, gaParams);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {
        this.off();
        this.stopListening();

        this.model = null;
        this.width = null;
        this.height = null;

        if (typeof this.transitionTimeout == 'number') clearTimeout(this.transitionTimeout);

        this.imageQsp = null;
        this.person = null;
        this.dimensions = null;

        return Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/contestant.js